<template>
	<div class="editButtons">
		<h2>{{ componentName }}</h2>
		<button type="submit" class="btn btn-secondary ml-auto moveUp" @click.stop.prevent="moveUp(index)" v-if="index !== 0">
				<img src="~@/assets/icons/scroll-arrow-to-up.svg">
		</button>
		<button type="submit" class="btn ml-auto moveDown" @click.stop.prevent="moveDown(index)" v-if="index !== contentClone.componentData.length - 1">
				<img src="~@/assets/icons/scroll-arrow-to-down.svg">
		</button>
		<button type="submit" class="btn ml-auto btn--delete delete" @click.stop.prevent="removeComponent(index)">
			<img src="~@/assets/icons/rubbish-bin.svg">
		</button>
	</div>
</template>

<script>
	export default {
		
		name: 'EditButtons',

		props: ['component-name', 'contentClone', 'index'],

		methods: {

			removeComponent(index) {
				if(confirm("Are you sure you want to delete this component?")) {
					this.contentClone.componentData = this.contentClone.componentData.filter((el, i) => i !== index);	
				}
			},

			moveUp(index) {
				this.contentClone.componentData = this.insertAndShift(this.contentClone.componentData, index, index - 1);
			},

			moveDown(index) {
				this.contentClone.componentData = this.insertAndShift(this.contentClone.componentData, index, index + 1);
			},
			
			insertAndShift(arr, from, to) {
				let newArr = [...arr];
				let cutOut = newArr.splice(from, 1)[0]; 
				newArr.splice(to, 0, cutOut);
				return newArr;
			}

		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	.editButtons{
		padding: 20px 0;
	}

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}

	.btn {
		position: absolute;
		
		&--delete {
			float: right;
		}

	}
	.moveUp{
		left: -5%;
	}
	.moveDown{
		left: -5%;
		margin-top:50px;
	}
	.delete{
		right:-6.4%;
	}
	.remove{
		right:-5%;
	}

	h2 {
		display: inline-block;
		text-transform: capitalize;
		margin-right: 15px;
	}
	
</style>